module.exports = __webpack_public_path__ + "static/media/trash.796dc6de.svg";